<template>
	<el-cascader placeholder="选择" v-model="shuju" :options="shu" @change="Change" :props="xiabiao" filterable :clearable="clearable"></el-cascader>
</template>

<script>
	import dizhiku from '../plugins/dizhiku.js'
	export default {
		data() {
			return {
				shuju: []
			}
		},
		props: {
			yiji: {
				type: [Number, String],
			},
			erji: {
				type: [Number, String],
			},
			shanji: {
				type: [Number, String],
			},
			shu: {
				type: Array
			},
			clearable:{
				type:Boolean
			},			
			xiabiao: {
				type: [Object, Array],
				default () {
					return {
						value: 'id',
						label: 'ming',
						children: 'haizi'
					}
				}
			}
		},
		created() {
			this.shuju[0] = this.yiji;				
			if(Number(this.erji)){				
				this.shuju[1] = this.erji;
				if(Number(this.shanji)){
					this.shuju[2] = this.shanji;
				}
			}				
		},
		methods: {
			Change(e) {
				this.$emit('update:yiji', e[0] || '');
				this.$emit('update:erji', e[1] || '');
				this.$emit('update:shanji', e[2] || '');
			}
		}
	}
</script>

<style>


</style>
